module.exports = __webpack_public_path__ + "img/partner_img.9bb1ba8c.png";